// src/HomePage.jsx
import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { Users, Award, Truck, Shield } from 'lucide-react';

const HomePage = () => {
  const navigate = useNavigate();
  
  const pageVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } }
  };

  return (
    <motion.div
      initial="hidden"
      animate="visible"
      variants={pageVariants}
      className="min-h-screen"
    >
      {/* Hero Section */}
      <section className="relative h-screen flex items-center justify-center bg-gradient-to-r from-brand-navy to-brand-gray text-white">
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <div className="relative z-10 text-center px-4 max-w-4xl">
          <motion.h1 
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="text-5xl md:text-7xl font-bold mb-6"
          >
            Onur İnşaat ve Beton
          </motion.h1>
          <motion.p 
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4 }}
            className="text-xl md:text-2xl mb-8 max-w-2xl mx-auto"
          >
            Kalite ve Güvenle Üretilen Hazır Beton Çözümleri
          </motion.p>
          <motion.button
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6 }}
            onClick={() => navigate('/products')}
            className="bg-brand-orange hover:bg-orange-600 text-white font-bold py-3 px-8 rounded-full text-lg transition duration-300 transform hover:scale-110"
          >
            Ürünlerimizi Keşfedin
          </motion.button>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-brand-navy mb-4">Neden Onur İnşaat ve Beton?</h2>
            <p className="text-xl text-brand-gray">Sektördeki liderliğimizi güçlendiren özelliklerimiz</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {[
              { icon: Users, title: "Deneyimli Ekip", desc: "Uzman kadromuzla kaliteli hizmet" },
              { icon: Award, title: "Kalite Garantisi", desc: "Sertifikalı üretim süreçleri" },
              { icon: Truck, title: "Hızlı Teslimat", desc: "Zamanında ve güvenli sevkiyat" },
              { icon: Shield, title: "Güvenilir Hizmet", desc: "Müşteri memnuniyeti odaklı" }
            ].map((feature, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.2 * index }}
                className="text-center p-6 rounded-lg hover:shadow-lg transition duration-300"
              >
                <feature.icon className="w-16 h-16 text-brand-orange mx-auto mb-4" />
                <h3 className="text-xl font-semibold text-brand-navy mb-2">{feature.title}</h3>
                <p className="text-brand-gray">{feature.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-brand-orange text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold mb-4">Projeniz İçin İletişime Geçin</h2>
          <p className="text-xl mb-8">Size en uygun beton çözümlerini sunmak için buradayız</p>
          <button
            onClick={() => navigate('/contact')}
            className="bg-white text-brand-orange font-bold py-3 px-8 rounded-full text-lg hover:bg-gray-100 transition duration-300 transform hover:scale-110"
          >
            İletişime Geçin
          </button>
        </div>
      </section>
    </motion.div>
  );
};

export default HomePage;